import { Injectable } from '@angular/core';

export type UserListViewMode = 'card' | 'table';

@Injectable({
  providedIn: 'root',
})
export class HomeUserListStateService {
  private filterTexts = new Map<string, string>();
  private inactiveFlags = new Map<string, boolean>();
  private viewModes = new Map<string, UserListViewMode>();

  setFilterText(key: string, value: string): void {
    this.filterTexts.set(key, value);
  }

  getFilterText(key: string): string {
    return this.filterTexts.get(key) ?? '';
  }

  setInactiveOnly(key: string, value: boolean): void {
    this.inactiveFlags.set(key, value);
  }

  getInactiveOnly(key: string): boolean {
    return this.inactiveFlags.get(key) ?? false;
  }

  setViewMode(key: string, value: UserListViewMode): void {
    this.viewModes.set(key, value);
  }

  getViewMode(key: string): UserListViewMode | null {
    return this.viewModes.get(key) ?? null;
  }
}
